import React, { Component } from 'react';
// Composants
import { Button } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ContextMenu from './ContextMenu';
// Librairies
import { contextMenu } from 'react-contexify';
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons';

export default class ThreeDotsMenu extends Component {
  state = {
    isOpen: false
  };

  handleOpenMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Si le menu est déjà ouvert, on ferme tous les menus actifs
    if (this.state.isOpen) {
      contextMenu.hideAll();
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const menuWidth = 240;

    // On positionne par défaut en bas à droite du bouton
    let x = rect.right - menuWidth;
    let y = rect.bottom + 4;

    // Sécurité axe horizontal
    if (rect.right + menuWidth > window.innerWidth)
      x = window.innerWidth - menuWidth - 10;
    if (x < 10) x = 10;

    // Si le menu dépasse en bas de l'écran
    const estimatedMenuHeight = 250;
    if (rect.bottom + estimatedMenuHeight > window.innerHeight)
      y = rect.top - estimatedMenuHeight - 4;

    // Sécurité axe vertical haut
    if (y < 10) y = 10;

    contextMenu.show({ id: this.props.id, event: e, position: { x, y } });
  };

  handleVisibilityChange = (isVisible) => {
    this.setState({ isOpen: isVisible });
    if (this.props.onVisibilityChange)
      this.props.onVisibilityChange(isVisible);
  };

  render() {
    return (
      <>
        <Button onClick={this.handleOpenMenu} style={{ padding: '7px', margin: 0 }}>
          <FontAwesomeIcon icon={faEllipsisVertical} style={{ aspectRatio: '1/1' }} />
        </Button>
        <ContextMenu id={this.props.id} items={this.props.items} onVisibilityChange={this.handleVisibilityChange} />
      </>
    );
  }
}